import { render, staticRenderFns } from "./question.vue?vue&type=template&id=392ff63e&scoped=true"
import script from "./question.vue?vue&type=script&lang=ts"
export * from "./question.vue?vue&type=script&lang=ts"
import style0 from "./question.vue?vue&type=style&index=0&id=392ff63e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392ff63e",
  null
  
)

export default component.exports